import axios from 'axios';

export const clientBoxApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-box`,
    headers: {
        'Content-Type': 'application/json'
    }
})